"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthController = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const AppControllerBase_1 = require("./AppControllerBase");
const models_1 = require("../api/classes/models");
class AuthController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._onLoginToken = new gs.EventGSToken();
        this.onLogin = new gs.EventGS(this._onLoginToken);
        this._onLogoutToken = new gs.EventGSToken();
        this.onLogout = new gs.EventGS(this._onLogoutToken);
        this._lastSID = "";
    }
    initialize() {
        const sid = gs.web.getCookie("SID");
        if (!sid)
            return;
        this._lastSID = sid;
        this._setSIDCookie();
        //this.tryRefreshTokenAsync(); перенес в инициализацию в APP
    }
    get user() { return this._user; }
    get phone() {
        if (!this._user)
            return "";
        const auth = this._user.auths.find(a => a.authType == models_1.AuthTypeEnum.Phone);
        if (!auth)
            return "";
        return auth.data;
    }
    get email() {
        if (!this._user)
            return "";
        const auth = this._user.auths.find(a => a.authType == models_1.AuthTypeEnum.Email);
        if (!auth)
            return "";
        return auth.data;
    }
    authAsync(callback = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            this.app.gui.showPopAuth(callback);
        });
    }
    dropAuthAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.gui.lockAction(App_1.App.Inst.api.authService.dropAuthSession());
            this._lastSID = "";
            this._user = undefined;
            this._setSIDCookie();
            yield this._setTokenAsync();
        });
    }
    tryAuthByPhoneAsync(phone) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new models_1.AuthService_TryAuthByPhone_Request();
            data.phone = phone;
            if (this._lastSID)
                this._setSIDCookie();
            else
                gs.web.deleteCookie("SID");
            const sid = yield App_1.App.Inst.gui.lockAction(App_1.App.Inst.api.authService.tryAuthByPhone(data));
            if (!sid)
                return false;
            this._lastSID = sid;
            this._setSIDCookie();
            return true;
        });
    }
    tryConfirmSMSAsync(code, args) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = new models_1.AuthService_ConfirmAuthCode_Request();
            data.code = code;
            const token = yield App_1.App.Inst.gui.lockAction(App_1.App.Inst.api.authService.confirmAuthCode(data, args));
            if (!token)
                return false;
            yield this._setTokenAsync(token);
            return true;
        });
    }
    tryRefreshTokenAsync(withRefresh = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const sid = gs.web.getCookie("SID");
            if (!sid)
                return;
            const data = new models_1.AuthService_CheckAuthOrEmpty_Request();
            data.withRefresh = withRefresh;
            const token = yield App_1.App.Inst.gui.lockAction(App_1.App.Inst.api.authService.checkAuthOrEmpty(data, { skip: true }));
            if (!token)
                return false;
            yield this._setTokenAsync(token);
            return true;
        });
    }
    _setSIDCookie() {
        gs.web.deleteCookie("SID");
        if (this._lastSID) {
            const expires = new Date();
            expires.setDate(expires.getDate() + 180);
            gs.helpers.web.setCookie("SID", this._lastSID, { expires: expires });
        }
    }
    _setTokenAsync(token = "") {
        return __awaiter(this, void 0, void 0, function* () {
            this._token = token;
            if (this._token) {
                this.app.api.getHTTPClient().setHeader("Authorization", "Bearer " + this._token);
                const user = yield this.app.api.profilesService.getMyUser({ skip: true });
                if (!user)
                    return;
                this._user = user;
                this._onLoginToken.invoke(user);
            }
            else {
                this.app.api.getHTTPClient().setHeader("Authorization", "");
                this._onLogoutToken.invoke();
            }
        });
    }
}
exports.AuthController = AuthController;
//# sourceMappingURL=AuthController.js.map